export const MuiDialogActionsTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                borderTop: `1px solid ${dt.color.outlineVariant}`,
                padding: dt.space.inline.large,
                background: dt.color.palette.neutrals[99],
            },
        },
    };
};
